module.exports = __webpack_public_path__ + "static/media/stadium.1a1e0d9d.webp";